import React from 'react';

import { ContentBlock } from 'components/modules/AutoruLayout/ContentBlock/ContentBlock';
import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';
import { Loading } from 'components/modules/Insurance/components/Loading/Loading';
import { Button } from 'components/uikit/Button/Button';

import * as S from '../../Insurance.styles';

import { VehicleStatus } from '../VehicleStatus/VehicleStatus';
import { PageBottom } from '../PageBottom/PageBottom';
import { Stepper } from '../Stepper/Stepper';

import { OtherInformation } from './components/OtherInformation/OtherInformation';
import { PtsInformation } from './components/PtsInformation/PtsInformation';
import { PurchaseMethod } from './components/PurchaseMethod/PurchaseMethod';
import { useVehicleInformationPresenter } from './VehicleInformation.presenter';

export const VehicleInformation = () => {
  const presenter = useVehicleInformationPresenter();

  return (
    <Page
      aside={<Stepper />}
      bottom={
        !presenter.loading && (
          <PageBottom>
            <Button disabled={presenter.disabled} size="m" theme="1" onClick={presenter.onSubmit}>
              Продолжить
            </Button>
          </PageBottom>
        )
      }
    >
      {presenter.loading && <Loading />}
      {!presenter.loading && (
        <>
          <PageContent
            title="Сведения о транспортном средстве"
            top={
              presenter.warnings.message && (
                <S.PageWarningCard
                  text={presenter.warnings.message}
                  onClick={presenter.warnings.onRemove}
                />
              )
            }
          >
            <ContentBlock>
              <VehicleStatus />
              <OtherInformation />
            </ContentBlock>
            <ContentBlock title="ПТС">
              <PtsInformation />
            </ContentBlock>
          </PageContent>
          <PageContent title="Способ приобретения автомобиля">
            <ContentBlock>
              <PurchaseMethod />
            </ContentBlock>
          </PageContent>
        </>
      )}
    </Page>
  );
};
